<template>
<m-pageframe
    :title="title"
>
<v-container
    fluid
    style="padding-left: 15px; padding-right: 15px;"
>

    <v-row
        style="margin-bottom: -35px"
    >
        <v-col>
            <v-text-field
                autocomplete="off"
                label="Search"
                prepend-icon="mdi-magnify"
                v-model="full_text"
                v-on:input="update"
            >
                <v-menu
                    bottom
                    offset-y
                    slot="append-outer"
                >
                    <template v-slot:activator="{ on }">
                        <v-icon
                            v-on="on"
                        >
                            mdi-dots-vertical
                        </v-icon>
                    </template>
            
                    <v-list>
                        <v-list-item
                            v-on:click="onClickExport()"
                        >
                            <v-list-item-title>Export to Excel...</v-list-item-title>
                        </v-list-item>
                    </v-list>
                </v-menu> 
            </v-text-field>
        </v-col>

        <v-col
            v-if="$route.query.add_to_bulk_message_id != null"
            style="flex-grow: 0"
        >
            <v-btn
                style="margin-top: 15px"
                color="primary"
                v-on:click="onClickAddToBulkMessage"
            >
                Add Guests to Bulk Message...
            </v-btn>
        </v-col>
    </v-row>


    <v-row>

        <v-col>
            <m-edit-date
                label="Start Date"
                v-model="date_start"
                v-on:input="doUpdate"
            />
        </v-col>

        <v-col>
            <m-edit-date
                label="Stop Date"
                v-model="date_stop"
                v-on:input="doUpdate"
            />
        </v-col>

        <v-col>
            <v-select
                label="Reservation State"
                :items="reservation_state_choices"
                v-model="state"
                v-on:change="doUpdate"
                :append-outer-icon="$route.params.content_type == 'commerce7' ? 'mdi-information-outline' : null"
                v-on:click:append-outer="onClickCommerce7ReservationStateHelp"
            />
        </v-col>

        <v-col>
            <v-select
                label="Reservation Location"
                :items="reservation_location_choices"
                item-text="value_label"
                item-value="value_id"
                v-model="location"
                v-on:change="doUpdate"
                return-object
            />
        </v-col>

        <v-col>
            <v-select
                label="Reservation Type"
                :items="reservation_type_choices"
                item-text="value_label"
                item-value="value_id"
                v-model="type"
                v-on:change="doUpdate"
                return-object
            />
        </v-col>


    </v-row>

    <v-data-table
        v-if="results != null"
        :headers="headers"
        :items="results"
        :items-per-page="100"
        class="elevation-1"
        :hide-default-footer="true"
        disable-sort
        :footer-props="{
            disableItemsPerPage: false,
            disablePagination: false,
        }"
    >

        <template v-slot:item.endpoints="{ item }">
            <div
                v-for="(number, index) in item.endpoints"
                :key="index"
            >
                    {{$rc.pretty(number,'endpoint')}}
            </div>
        </template>

        <template v-slot:item.action="{ item }">
            <v-menu 
                bottom 
                offset-y  
            >
            
            <template v-slot:activator="{ on }">
                    
                <v-icon 
                    v-on="on"
                >
                    mdi-dots-vertical
                </v-icon>
                    
            </template>
            
            <v-list>
                <v-list-item
                    v-on:click="onClickViewInCrm(item)"
                    v-if="item.url_view_in_crm != null"
                >
                    <v-list-item-title>View in {{crm_name}}...</v-list-item-title>
                </v-list-item>

                <v-list-item
                    v-on:click="onClickTechnicalData(item)"
                >
                    <v-list-item-title>Technical Details...</v-list-item-title>
                </v-list-item>

                <v-list-item
                    v-on:click="onClickTechnicalDataRaw(item)"
                >
                    <v-list-item-title>Technical Details (raw data sent by {{crm_name}})...</v-list-item-title>
                </v-list-item>
            
            </v-list>
            
            </v-menu> 
        </template>
    
    </v-data-table>

</v-container>
</m-pageframe>
</template>

<script>
const _ = require('lodash');

export default {

    data() {
        return {
            full_text: null,
            results: [],
            date_start: null,
            date_stop: null,
            state: 'any_enum_value',

            headers: [
                { text: 'Brand', value: 'brand_label'},
                { text: 'Location', value: 'location_label'},

                { text: 'Date', value: 'reservation_location_timezone_start_date'},
                { text: 'Time', value: 'reservation_location_timezone_start_wall_time'},
                { text: 'Type', value: 'type_label'},


                { text: 'Timezone', value: 'reservation_location_timezone'},

                { text: 'First Name', value: 'first_name'},
                { text: 'Last Name', value: 'last_name'},
                { text: 'Guest Count', value: 'guest_count'},
                { text: 'State', value: 'state'},
                { text: 'Phone', 'value' : 'endpoints' },
                { text: 'Action', value: 'action'},
            ],

            reservation_location_choices: [],
            reservation_type_choices: [],

            location: 'any_enum_value',
            type: 'any_enum_value',
        }
    },

               


    mounted () {
        this.doUpdate();
    },

    methods: {
        update: _.debounce(function(){
            this.doUpdate();
        }, 751),

        createSearch()
        {
            let state = this.state;
            if ( state == 'any_enum_value' ) state = null;

            let location_id = this.location.value_id == 'any_enum_value' ? null : this.location.value_id;
            let type_id = this.type.value_id == 'any_enum_value' ? null : this.type.value_id;

            return {
                    'full_text': this.full_text,
                    'organization_id' : this.$route.params.organization_id,
                    'content_type' : this.$route.params.content_type,
                    'date_start': this.date_start,
                    'date_stop': this.date_stop,
                    'state': state,
                    'location_id': location_id,
                    'type_id': type_id,
                };
        },
        
        doUpdate()
        {
            this.$rc.rest(
                'LIST: /api/v1/integrations/crm/reservations',
            
                this.createSearch(),
            
                (data) => {
                    this.results = data.results;

                    this.reservation_location_choices = [{
                        "settings_id": "00000000-0000-0000-0000-000000000000",
                        "value_id": "any_enum_value",
                        "value_label": "Any Location"
                    }]
                    .concat(data.reservation_locations.values);

                    this.reservation_type_choices = [{
                        "settings_id": "00000000-0000-0000-0000-000000000000",
                        "value_id": "any_enum_value",
                        "value_label": "Any Type"
                    }]
                    .concat(data.reservation_types.values);
                },
            
                () => {
                    this.$rc.alert('Error','Unable to search reservations');
                },
            );
        },

        onClickViewInCrm(item)
        {
            window.open(item.url_view_in_crm,"_blank");
        },

        onClickTechnicalData(item)
        {
            this.$rc.copy_code_dialog({
                    'title': 'Technical Details',
                    'object': item,
                });
        },

        onClickTechnicalDataRaw(item)
        {
            try {
                let object = JSON.parse(item.reservation_raw_content);

                this.$rc.copy_code_dialog({
                    'title': 'Technical Details',
                    'object': object,
                });
            } 
            catch (e) 
            {
                this.$rc.copy_code_dialog({
                    'title': 'Technical Details',
                    'code': item.reservation_raw_content,
                });
            }
        },

        onClickExport()
        {
            this.$rc.excelExport(
                    'EXPORT: /api/v1/integrations/crm/reservations',
                    this.createSearch()
                );
        },
        
        onClickAddToBulkMessage()
        {
            this.$rc.startProcess({
                'type': 'crm-add-reservation-guests-to-bulk-message',
            
                'params': {
                    ... this.createSearch(),
                    'bulk_message_id': this.$route.query.add_to_bulk_message_id,
                },
            
                'title': 'Adding reservation guests to bulk message',
                'finished_button_text': 'Preview Recipients',
                'failed_button_text': 'Cancel',
            
                status: (pte) => {
                    return 'Customer phone numbers: '+pte.progress_counter;
                },
            
                on_finished: (pte) => {
                    this.$router.push({
                        'name': 'bulk-recipient-preview',
                        'params' : {
                            'organization_id' : pte.output.organization_id,
                            'bulk_message_id' : pte.output.bulk_message_id,
                            'import_id' : pte.output.import_id
                        }
                    });
                },
            
                on_failed: (pte) => {
                },
            
            });
        },

        onClickCommerce7ReservationStateHelp()
        {
            this.$rc.alert('Commerce7 Reservation State', 'For the completed state to be accurate you must be setting reservations to "checked in" or "closed out" in the normal course of your operations.');
        },
    },

    computed: {
        title() {
            return 'Search '+this.$rc.pretty(this.$route.params.content_type, 'enum_integration_name')+' Reservations';
        },

        crm_name() {
            return this.$rc.pretty(this.$route.params.content_type, 'enum_integration_name');
        },

        reservation_state_choices() {
            let ret = this.$rc.enumChoices('reservation_state', true);

            return ret.filter((el) => el.value == 'any_enum_value' || el.integrations_that_support_this_state.includes(this.$route.params.content_type));
        },
    },
}
</script>

<style lang="scss" scoped>
</style>